import router from '@/router/index';
import {CurrentDiagNavigation,ResumeFsm} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs, navigate } = api;
    let here = parent.active;

    here.init
      .to(here.currentdiag);
    here.currentdiag
    .to()
    .when(messageIs(ResumeFsm))
    .effect(()=>navigate(CurrentDiagNavigation));
  }
};